import {
  CONFIRMATION,
  HOME,
  OFFERS,
  PAX,
  PAYMENT,
} from '@/hooks/usePriceFreezeRouter';

export const PF_CATEGORY_MAP = {
  [HOME]: 'pf_summary',
  [OFFERS]: 'pf_primeplus_page',
  [PAX]: 'pf_pax_page',
  [PAYMENT]: 'pf_pay_page',
  [CONFIRMATION]: 'pf_confirmation',
};

export const PF_PAGE_VIEW_MAP = {
  [HOME]: 'summary',
  [OFFERS]: 'save-with-prime-plus',
  [PAX]: 'details-extras',
  [PAYMENT]: 'payment',
  [CONFIRMATION]: 'confirmation',
  pf_intermediate: 'price-freeze-intermediate',
  flights_pax_page: 'flights_pax_page',
};

export const TRACKING_ACTION = 'price-freeze';

export const ACTIONS = {
  HEADER: {
    BACK: '_click:back_dep:Z',
  },
  BANNER: {
    ONLOAD: '-banner_onload',
    CLICK: {
      EXPAND: '-banner_click:expand',
      COLLAPSE: '-banner_click:collapse',
      UNDERSTOOD: '-banner_click:understood',
      GOT_IT: '-banner_click:got-it',
    },
  },
  DOUBLEBUTTONDESKTOP: {
    ONLOAD: '-button_onload',
    CLICK: '-button_click_dep:Z',
  },
  TEXTLINK: {
    ONLOAD: '-link_onload_dep:Z',
    CLICK: '-link_click_dep:Z',
  },
  CARD: {
    ONLOAD: '-banner_onload_dep:Z',
    CLICK: '-banner_click_dep:Z',
  },
  TOPCARD: {
    ONLOAD: '-top-banner_onload_dep:Z',
    CLICK: '-top-banner_click_dep:Z',
  },
  LEARN_MORE: {
    ONLOAD: '-info_onload:about-pf',
    CLICK: {
      OPEN: '_click:info',
      PRIME: '-info_click:prime',
      TERMS: '-info_click:terms',
    },
    ONCLOSE: '-info_close:x',
    ONFADE: '-info_close:back-ground', // unused
  },
  HOME: {
    CLICK: {
      CONTINUE: '_continue:summary_dep:Z',
      CLOSE: '_close:summary_dep:Z',
    },
  },
  HOMEPAX: {
    ERRORONLOAD: '-error_onload:non-prime-email_dep:Z',
    CLICK: {
      BACKTOTRIPSUMMARY: '-link_click:go-back-ts_dep:Z',
      CLOSE: '_close_dep:Z',
    },
  },
  INTERMEDIATE: {
    CLICK: {
      PFCONTINUE: '_continue:fl-pf_dep:Z',
      CONTINUE: '_continue:fl_dep:Z',
    },
  },
  PAXDOUBLEBUTTON: {
    ONLOAD: '-button_onload',
    CLICK: {
      PFCONTINUE: '-button_continue',
    },
  },
  PAX: {
    CLICK: {
      CONTINUE: '_continue_dep:Z',
    },
  },
  PAYMENT: {
    CLICK: {
      OPEN_DETAILS: '_open:price-details',
      CLOSE_DETAILS: '_close:price-details',
      GENERAL_TERMS: '_click:terms',
      PF_TERMS: '_click:pf-terms',
      PURCHASE_OK: '-purchase_dep:Z',
      PURCHASE_KO: '-purchase-error_dep:Z',
      EDIT_CONTACT_DETAILS_LINK: '_click:edit-details',
      EDIT_CONTACT_DETAILS_BUTTON: '_click:confirm-details',
      EDIT_CONTACT_DETAILS_CLOSE: '_close:modal-details',
    },
    ONLOAD: {
      EDIT_CONTACT_DETAILS_MODAL: '_onload:pax-details',
    },
  },
  ERROR: {
    PURCHASE: '-purchase-error_dep:Z', // unable to send
  },
  CONFIRMATION: {
    CLICK: {
      TERMS: '_click:terms',
      DOWNLOAD: '_click:app',
      GO_HOME: '_click:back',
    },
  },
  NO_PRIME: {
    CLICK: {
      CONTINUE: '_continue:free-trial_dep:Z',
      MORE_INFO: '_click:info',
      HELP_CENTER: '_click:help-center',
      PRIVACY_NOTICE: '_click:privacy-notice',
      PRIME_TERMS: '_click:prime-terms',
    },
  },
  BUBBLE: {
    LOAD: '-bubble_onload',
    CLICK: {
      CLOSE: '-bubble_close',
      CONTINUE: '-button_continue',
    },
    BTN_LOAD: '-button_onload',
  },
};
